<template>
  <div class="app-layout" :class="{ 'is-collapsed': collapsed }">
    <sidebar />
    <section class="app-layout__main">
      <navbar />
      <main class="app-main">
        <div class="app-main__view">
          <transition name="fade-transform" mode="out-in">
            <router-view :key="$route.fullPath" />
          </transition>
        </div>
      </main>
    </section>
  </div>
</template>

<script>
import Sidebar from './components/Sidebar.vue'
import Navbar from './components/Navbar.vue'

export default {
  name: 'AppLayout',
  components: { Sidebar, Navbar },
  computed: {
    collapsed() {
      return this.$store.state.app.preferences.sidebarCollapsed
    }
  }
}
</script>
